import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import {
  Row, Col, Container,
} from 'reactstrap';
import step11 from 'assets/img/step11.png';
import step12 from 'assets/img/step12.png';
import step21 from 'assets/img/step21.png';
import step22 from 'assets/img/step22.png';
import step31 from 'assets/img/step31.png';
import step32 from 'assets/img/step32.png';
import step41 from 'assets/img/step41.png';
import step42 from 'assets/img/step42.png';
import {
  SlickCarousel, Intl, Form, NewCampaign2Step1, NewCampaign2Footer,
  NewCampaign2Step2, NewCampaign2Step3, NewCampaign2Step4, ConfirmationModal,
  BeforeOutAlert, LinkLegal,
} from 'components';

export default ( {
  campaignId, options, isLoading, onSubmit, blockNavigationAlert, setBlockNavigationAlert, dataTeampleader,
} ) => {
  const [steps, setSteps] = useState( [
    {
      step: 0, completed: false, img: step11, completedImg: step12, label: 'where',
    },
    {
      step: 1, completed: false, img: step21, completedImg: step22, label: 'when',
    },
    {
      step: 2, completed: false, img: step31, completedImg: step32, label: 'what',
    },
    {
      step: 3, completed: false, img: step41, completedImg: step42, label: 'who',
    },
  ] );
  const sliderRef = useRef( null );
  const [currentStep, setCurrentStep] = useState( 0 );
  const [confirmChangeStep3ModalOpened, setConfirmChangeStep3Opened] = useState( false );
  const [confirmTtsModalOpened, setConfirmTtsOpened] = useState( false );
  const [confirmIvrModalOpened, setConfirmIvrOpened] = useState( false );
  const [deleteContactModalOpened, setDeleteContactModalOpened] = useState( false );
  const [validCost, setValidCost] = useState( false );
  const formRef = useRef( null );
  const onChangeCbStep3Ref = useRef( null );

  const toggleCompletedStep = useCallback( ( stepsValue ) => {
    const newSteps = _.cloneDeep( steps );
    _.map( stepsValue, ( step ) => {
      const stepIndex = _.findIndex( newSteps, { step: step.step } );
      if ( stepIndex !== -1 ) {
        newSteps[stepIndex] = { ...newSteps[stepIndex], completed: step.completed };
      }
    } );

    setValidCost( _.filter( newSteps, { completed: true } ).length === steps.length );
    setSteps( newSteps );
  }, [steps] );

  const onNextStep = useCallback( () => {
    setCurrentStep( currentStep + 1 );
  }, [currentStep] );

  const onPrevStep = useCallback( () => {
    setCurrentStep( currentStep - 1 );
  }, [currentStep] );

  const gotToStep = useCallback( ( step ) => {
    setCurrentStep( step );
    sliderRef.current.slickGoTo( step );
  }, [] );

  useEffect( () => {
    if ( currentStep === 1 ) {
      const { values } = formRef.current.getState();
      if ( !values.startDate ) {
        formRef.current.change( 'startDate', moment.tz( values.timeZone ) );
      }
      if ( !values.startTime ) {
        formRef.current.change( 'startTime', moment.tz( values.timeZone ) );
      }
      if ( values.startDate && values.startTime ) {
        const date = `${moment( values.startDate ).format( 'MM/DD/YYYY' )} ${moment( values.startTime ).format( 'HH:mm' )}`;
        if ( moment.tz( date, 'MM/DD/YYYY HH:mm', true, values.timeZone ).diff( moment.tz( values.timeZone ), 'minutes' ) <= 0 ) {
          formRef.current.change( 'startDate', moment.tz( values.timeZone ) );
          formRef.current.change( 'startTime', moment.tz( values.timeZone ) );
        }
      }

      toggleCompletedStep( [{ step: 1, completed: true }] );
    }
  }, [currentStep] ); //eslint-disable-line

  const clearAudios = useCallback( ( values ) => {
    if ( values.singleFile ) formRef.current.change( 'singleFile', null );
    if ( values.introductionFile ) formRef.current.change( 'introductionFile', null );
    if ( values.optionsFile ) formRef.current.change( 'optionsFile', null );
    if ( values.farewellFile ) formRef.current.change( 'farewellFile', null );

    onChangeCbStep3Ref.current = null;
    toggleCompletedStep( [{ step: 2, completed: false }] );
    setConfirmChangeStep3Opened( false );
  }, [toggleCompletedStep] );

  const openConfirmChangeStep3Modal = useCallback( ( values, cb ) => {
    if ( values.singleFile || values.introductionFile
      || values.optionsFile || values.farewellFile ) {
      setConfirmChangeStep3Opened( true );
      onChangeCbStep3Ref.current = cb;
    } else {
      onChangeCbStep3Ref.current = null;
    }
  }, [] );

  const closeConfirmChangeStep3Modal = useCallback( () => {
    if ( onChangeCbStep3Ref.current ) onChangeCbStep3Ref.current();
    setConfirmChangeStep3Opened( false );
  }, [] );

  const toggleConfirmTtsModal = useCallback( () => {
    setConfirmTtsOpened( !confirmTtsModalOpened );
  }, [confirmTtsModalOpened] );

  const toggleConfirmIvrModal = useCallback( () => {
    setConfirmIvrOpened( !confirmIvrModalOpened );
  }, [confirmIvrModalOpened] );

  const toggleDeleteContactModal = useCallback( () => {
    setDeleteContactModalOpened( !deleteContactModalOpened );
  }, [deleteContactModalOpened] );

  const resetContacts = useCallback( () => {
    formRef.current.change( 'contacts', [] );
    toggleCompletedStep( [{ step: 3, completed: false }] );
    toggleDeleteContactModal();
  }, [toggleDeleteContactModal, toggleCompletedStep] );

  return (
    <Form
      onSubmit={() => {}}
      showErrorsInHeader
      body={( form ) => {
        const { values } = form.getState();
        const step1Completed = values.country && values.timeZone;
        formRef.current = form;

        return (
          <Container
            fluid
            className={classnames( 'campaign-wizard mt-3', { 'app-component-loading': isLoading } )}
          >
            <BeforeOutAlert
              isActive={blockNavigationAlert}
              text="alertBeforeOutNewCampaign"
            />
            <Row>
              <Col md={8} lg={7} className="m-auto pl-5 pr-0">
                <Row className="pl-2">
                  {_.map( steps, ( step ) => (
                    <Col sm key={step.step} className="campaign-wizard-header p-0">
                      <div className={classnames( 'campaign-wizard-header-icon', {
                        disabled: !step1Completed && step.step !== 0,
                      } )}
                      >
                        {/* eslint-disable-next-line max-len */}
                        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                        <img
                          alt="..."
                          className="cursor-pointer"
                          src={step.completed ? step.completedImg : step.img}
                          onClick={() => ( step1Completed ? gotToStep( step.step ) : {} )}
                        />
                        <hr />
                      </div>
                      <p className={classnames( 'campaign-wizard-header-text', {
                        active: step.step === currentStep,
                      } )}
                      >
                        <Intl id={step.label} />
                      </p>
                    </Col>
                  ) )}
                </Row>
              </Col>
            </Row>

            <Row className="mt-md-5 mt-2">
              <Col>
                <SlickCarousel
                  ref={sliderRef}
                  onNext={onNextStep}
                  onPrev={onPrevStep}
                  nextDisabled={!step1Completed}
                >
                  <div>
                    <NewCampaign2Step1
                      options={options}
                      form={form}
                      values={values}
                      onComplete={toggleCompletedStep}
                      setBlockNavigationAlert={setBlockNavigationAlert}
                    />
                  </div>
                  <div>
                    <NewCampaign2Step2
                      currentStep={currentStep}
                      form={form}
                      values={values}
                    />
                  </div>
                  <div>
                    <NewCampaign2Step3
                      campaignId={campaignId}
                      form={form}
                      values={values}
                      onComplete={toggleCompletedStep}
                      onOpenChangeModal={( cb ) => openConfirmChangeStep3Modal( values, cb )}
                      onOpenTtsModal={toggleConfirmTtsModal}
                      onOpenIvrModal={toggleConfirmIvrModal}
                    />
                  </div>
                  <div>
                    <NewCampaign2Step4
                      campaignId={campaignId}
                      values={values}
                      options={options}
                      form={form}
                      onResetContacts={toggleDeleteContactModal}
                      onCompleteStep={toggleCompletedStep}
                      dataTeampleader={dataTeampleader}
                    />
                  </div>
                </SlickCarousel>
              </Col>
            </Row>

            <NewCampaign2Footer
              values={values}
              validCost={validCost}
              onSubmit={() => onSubmit( values )}
            />

            {confirmChangeStep3ModalOpened
            && (
              <ConfirmationModal
                title="campaignWizardChangeStep3Title"
                subtitle="campaignWizardChangeStep3Subtitle"
                open={confirmChangeStep3ModalOpened}
                onClose={closeConfirmChangeStep3Modal}
                onConfirm={() => clearAudios( values )}
                okLabel="okBtn"
                // notCancelBtn
              />
            )}

            {confirmTtsModalOpened
            && (
              <ConfirmationModal
                title={(
                  <span>
                    <Intl id="campaignWizardStep3TtsTitle" />
                    {' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="http://www.fromtexttospeech.com/"
                    >
                      <Intl id="here" />
                    </a>
                    .
                  </span>
                )}
                translateTitle={false}
                open={confirmTtsModalOpened}
                confirmClose
                onConfirm={toggleConfirmTtsModal}
                okLabel="okBtn"
               // notCancelBtn
              />
            )}

            {confirmIvrModalOpened
            && (
              <ConfirmationModal
                title={(
                  <span>
                    <Intl id="campaignWizardStep3IvrTitle1" />
                    {' '}
                    <LinkLegal
                      target="_blank"
                      rel="noopener noreferrer"
                      label="here"
                      href={{
                        es: 'https://massphoning.es/contactar/',
                        en: 'https://massphoning.com/contact/',
                      }}
                    />
                    {' '}
                    <Intl id="campaignWizardStep3IvrTitle2" />
                  </span>
                )}
                translateTitle={false}
                open={confirmIvrModalOpened}
                confirmClose
                onConfirm={toggleConfirmIvrModal}
                okLabel="okBtn"
                // notCancelBtn
              />
            )}

            {deleteContactModalOpened
            && (
              <ConfirmationModal
                title="resetPhones"
                open={deleteContactModalOpened}
                onConfirm={resetContacts}
                onClose={toggleDeleteContactModal}
                okLabel="okBtn"
               // notCancelBtn
              />
            )}
          </Container>
        );
      }}
    />
  );
};
